import type { ComponentProps } from 'react';

const AvatarFemale = (props: ComponentProps<'svg'>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
      fill="#FFF2E8"
    />
    <mask
      id="mask0_4993_126758"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#FFF2E8"
      />
    </mask>
    <g mask="url(#mask0_4993_126758)">
      <path
        d="M12.1629 5.16471C13.0891 5.16471 13.84 4.41385 13.84 3.48763C13.84 2.5614 13.0891 1.81055 12.1629 1.81055C11.2367 1.81055 10.4858 2.5614 10.4858 3.48763C10.4858 4.41385 11.2367 5.16471 12.1629 5.16471Z"
        fill="#5B1D1E"
      />
      <path
        d="M12.7904 17.2478H11.4103C9.28779 17.2478 7.56689 15.5269 7.56689 13.4044V9.01333C7.56689 6.89081 9.28779 5.16992 11.4103 5.16992H12.7904C14.9129 5.16992 16.6338 6.89081 16.6338 9.01333V13.4044C16.6363 15.5269 14.9154 17.2478 12.7904 17.2478Z"
        fill="#FFBF9F"
      />
      <path
        d="M7.56445 11.0964V9.0104C7.56445 6.88789 9.28535 5.16699 11.4079 5.16699H12.788C14.9105 5.16699 16.6314 6.88789 16.6314 9.0104V11.0964L11.9969 6.70533L7.56445 11.0964Z"
        fill="#5B1D1E"
      />
      <path
        d="M6.8283 13.723C7.60262 13.723 8.23033 13.0953 8.23033 12.321C8.23033 11.5467 7.60262 10.9189 6.8283 10.9189C6.05398 10.9189 5.42627 11.5467 5.42627 12.321C5.42627 13.0953 6.05398 13.723 6.8283 13.723Z"
        fill="#FFBF9F"
      />
      <path
        d="M17.3027 13.723C18.077 13.723 18.7047 13.0953 18.7047 12.321C18.7047 11.5467 18.077 10.9189 17.3027 10.9189C16.5283 10.9189 15.9006 11.5467 15.9006 12.321C15.9006 13.0953 16.5283 13.723 17.3027 13.723Z"
        fill="#FFBF9F"
      />
      <path
        d="M10.0262 12.4575C10.2829 12.4575 10.4911 12.1306 10.4911 11.7273C10.4911 11.324 10.2829 10.9971 10.0262 10.9971C9.76942 10.9971 9.56128 11.324 9.56128 11.7273C9.56128 12.1306 9.76942 12.4575 10.0262 12.4575Z"
        fill="#5B1D1E"
      />
      <path
        d="M14.6055 12.314C14.8623 12.314 15.0704 11.987 15.0704 11.5837C15.0704 11.1804 14.8623 10.8535 14.6055 10.8535C14.3488 10.8535 14.1406 11.1804 14.1406 11.5837C14.1406 11.987 14.3488 12.314 14.6055 12.314Z"
        fill="#5B1D1E"
      />
      <path
        d="M10.4826 13.4795L12.4055 14.7647C12.4055 14.7647 11.6339 15.8454 10.67 15.1858C9.74752 14.5529 10.4826 13.4795 10.4826 13.4795Z"
        fill="white"
      />
      <path
        d="M12.2632 10.8994V12.8686C12.2632 12.8686 13.1857 12.7517 13.12 13.2921C13.0786 13.6475 12.5309 14.015 12.5309 14.015"
        stroke="#5B1D1E"
        stroke-width="0.568957"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M26.153 37.3796H-1.83154V24.8734C-1.83154 21.1687 1.17211 18.165 4.87677 18.165H19.4447C23.1494 18.165 26.153 21.1687 26.153 24.8734V37.3796V37.3796Z"
        fill="#FFBF9F"
      />
      <mask
        id="mask1_4993_126758"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="-2"
        y="18"
        width="29"
        height="20"
      >
        <path
          d="M26.153 37.3796H-1.83154V24.8734C-1.83154 21.1687 1.17211 18.165 4.87677 18.165H19.4447C23.1494 18.165 26.153 21.1687 26.153 24.8734V37.3796V37.3796Z"
          fill="#FFBF9F"
        />
      </mask>
      <g mask="url(#mask1_4993_126758)">
        <path
          d="M12.9481 28.3027L-12.325 34.7457L2.67383 12.8877L12.9481 28.3027Z"
          fill="#F58D7A"
        />
        <path
          d="M-5.02026 30.7957L20.3988 14.777L28.0637 14.1758L29.9379 42.9344L-5.02026 30.7957Z"
          fill="#E06257"
        />
      </g>
    </g>
  </svg>
);

export default AvatarFemale;
